import { siteName, heroStats, quickLinks } from '@/mocks/home';

function jumpTo(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 pb-12 md:pt-32 md:pb-20">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-100 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-100 blur-3xl" />

      <div className="relative mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 md:px-6 lg:grid-cols-2 lg:gap-14">
        <div className="anim-rise">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-fire-line"></i>
            平台使用与入口指南
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-4xl lg:text-[42px]">
            {siteName}使用指南：
            <br className="hidden md:block" />
            会员免费看、打不开与换地址一次讲清
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这一页把{siteName}的常见使用问题集中整理：怎么下载 APP、官网入口怎么看、
            会员与免费观看的区别、以及遇到打不开或者需要换地址时的排查思路。
            不用翻来翻去，从上往下看就能找到对应的做法。
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={() => jumpTo('getting-started')}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              查看新手指南
            </button>
            <button
              type="button"
              onClick={() => jumpTo('troubleshoot')}
              className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-tools-line"></i>
              打不开排查
            </button>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroStats.map((s) => (
              <div key={s.label}>
                <dt className="font-heading text-xl font-bold text-primary-600 md:text-2xl">{s.value}</dt>
                <dd className="mt-1 text-xs leading-snug text-foreground-600 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="anim-rise lg:[animation-delay:120ms]">
          <div className="relative mx-auto w-full max-w-[520px]">
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20red%20movie%20streaming%20app%20interface%20on%20a%20smartphone%20screen%20surrounded%20by%20floating%20film%20poster%20cards%2C%20warm%20amber%20and%20deep%20red%20color%20grading%2C%20moody%20theater%20lighting%2C%20premium%20editorial%20product%20photography%2C%20soft%20shadow%2C%20clean%20minimal%20dark%20background&width=900&height=1080&seq=hero-hongtao-01&orientation=portrait"
                alt="红桃影视在手机上浏览影片的界面示意"
                className="h-auto w-full object-top"
              />
            </div>
            <div className="absolute -bottom-5 -left-4 hidden rounded-xl border border-background-200 bg-background-50 px-4 py-3 sm:block">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className="ri-checkbox-circle-line"></i>
                </span>
                <div>
                  <p className="text-xs font-medium text-foreground-900">入口稳定优先</p>
                  <p className="text-[11px] text-foreground-500">收藏固定入口最省心</p>
                </div>
              </div>
            </div>
            <div className="absolute -right-3 top-8 hidden rounded-xl border border-background-200 bg-background-50 px-4 py-3 md:block">
              <p className="font-heading text-lg font-bold text-accent-700">多端</p>
              <p className="text-[11px] text-foreground-500">手机 / 电脑通用</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mx-auto mt-12 max-w-[1200px] px-4 md:mt-16 md:px-6">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {quickLinks.map((q) => (
            <button
              key={q.title}
              type="button"
              onClick={() => jumpTo(q.anchor)}
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-100 text-primary-600 transition-colors group-hover:bg-primary-100">
                <i className={`${q.icon} text-xl`}></i>
              </span>
              <span>
                <span className="flex items-center gap-1 text-sm font-medium text-foreground-900">
                  {q.title}
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-transform group-hover:translate-x-0.5"></i>
                </span>
                <span className="mt-1 block text-xs leading-relaxed text-foreground-600">{q.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}